

export const Items = {
    add: (invoiceItemdispatch, data)=> invoiceItemdispatch({type:'ADD_ITEMS', payload:data}),
    delete: (invoiceItemdispatch, data)=> invoiceItemdispatch({type:'DELETE_ITEMS', payload:data}),
    remove:(invoiceItemdispatch, data)=>invoiceItemdispatch({type:'EMPTY_ITEMS', payload:data})
    
}

export const DemandIems={
    add:(demandLetterItemdispatch, data)=>demandLetterItemdispatch({type:'ADD_DEMANDITEMS', payload:data}),
    delete:(demandLetterItemdispatch, data)=>demandLetterItemdispatch({type:'DELETE_DEMANDITEMS', payload:data}),
    remove:(demandLetterItemdispatch, data)=>demandLetterItemdispatch({type:'EMPTY_DEMANDITEMS', payload:data})
}

export const LogisticsIems={
    add:(logisticsItemdispatch, data)=>logisticsItemdispatch({type:'ADD_LOGISTICSITEMS', payload:data}),
    delete:(logisticsItemdispatch, data)=>logisticsItemdispatch({type:'DELETE_LOGISTICSITEMS', payload:data}),
    remove:(logisticsItemdispatch, data)=>logisticsItemdispatch({type:'EMPTY_LOGISTICSITEMS', payload:data})
}
